import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { userType } from '../../../../../constants/global-constants';
import {ConsoleLogger} from '@angular/compiler-cli';

@Component({
  selector: 'app-profile-info',
  templateUrl: './profile-info.component.html',
  styleUrls: ['./profile-info.component.scss']
})
export class ProfileInfoComponent implements OnInit {

  userType = userType;
  progressTitle: Array<string> = ['', '', 'to go'];
  progressPercent = 0;
  @Input() dashboard: any;

  constructor(public authService: AuthService) {
  }

  ngOnInit(): void {
  }

  // tslint:disable-next-line:typedef use-lifecycle-interface
  ngAfterViewInit() {
    console.log(new Date().getDate());
    if (this.authService.user?.userType === this.userType.MUM) {
      const totalPregnancyDays = 294; // 42 weeks
      // @ts-ignore
      const value = new Date().getTime() - new Date(this.dashboard.dueDate).getTime();
      const difference = value / (1000 * 3580 * 24) ;
      const differenceinDays = totalPregnancyDays - parseInt(String(difference), 10);
      this.progressTitle[0] = Math.floor(differenceinDays / 7) + 'Weeks';
      this.progressTitle[1] = differenceinDays % 7  + ' Days';
      this.progressPercent = differenceinDays * 100 / totalPregnancyDays;
      this.progressPercent = 100 - this.progressPercent;
      if (this.progressPercent >= 100) {
        this.progressTitle = ['Due Date', '', 'Over'];
      }
    }
  }
}
